import React, { useState } from 'react';
import { Tabs, TabsContent } from '../../components/ui/tabs';
// import { Gauge } from 'lucide-react';
// Subscription Plans and One-Time Payments are parked: the Team plan's
// price is set on Pricing, and no one-time payment request has ever been sent.
// import { Package, DollarSign } from 'lucide-react';
// import PlanManagementSimple from './PlanManagementSimple';
// import PaymentRequests from './PaymentRequests';
import PricingSettings from './PricingSettings';

const PlansAndPayments: React.FC = () => {
  const [activeTab, setActiveTab] = useState('pricing');

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between flex-wrap gap-3 mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Plans & Payments</h1>
          <p className="text-sm text-gray-500 mt-0.5">
            Set the seat price, included usage, top-ups and margins
          </p>
        </div>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
        {/* The lone Pricing tab is hidden for now; the pricing panel shows on its own.
        <TabsList className="grid w-full grid-cols-1 max-w-[200px]">
          <TabsTrigger value="pricing" className="flex items-center gap-2">
            <Gauge size={16} />
            Pricing
          </TabsTrigger>
          <TabsTrigger value="plans" className="flex items-center gap-2">
            <Package size={16} />
            Subscription Plans
          </TabsTrigger>
          <TabsTrigger value="payments" className="flex items-center gap-2">
            <DollarSign size={16} />
            One-Time Payments
          </TabsTrigger>
        </TabsList>
        */}

        <TabsContent value="pricing" className="mt-0">
          <PricingSettings />
        </TabsContent>

        {/* <TabsContent value="plans" className="mt-0">
          <PlanManagementSimple />
        </TabsContent>

        <TabsContent value="payments" className="mt-0">
          <PaymentRequests />
        </TabsContent> */}
      </Tabs>
    </div>
  );
};

export default PlansAndPayments;
